import React, { FC } from 'react';

import { WizardPage } from '../../../../general/components/wizard-page';

const NoMatchingFleet: FC = () => {
  // TODO: Handle back button if needed
  return (
    <WizardPage
      title="You don't have an account"
      subtext={
        <>
          We are unable to find an account for the phone number you entered.
          <br /> <br />
          If you feel this is a mistake, please get in touch with your account manager to verify your phone number.
        </>
      }
    ></WizardPage>
  );
};

export { NoMatchingFleet };
